import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";
import users from "../../assets/images/icon_profile/user.svg";
import punishIcon from "../../assets/images/icon_violation/punish.svg";
import rewardIcon from "../../assets/images/icon_violation/reward.svg";
import Config from "../../config/Config";
import { handleLongText } from "../../config/global";
import { setLanguage } from "../../core/feature/language/languageSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { credentialCheck } from "../../core/service/api";
import { i18n } from "../../translations/i18n";

const ViolationPointMobile = ({
  getProfileImage = (e: string) => users,
  changeStudent = (e: any) => { },
  getComboStudent = () => { },
  studentSelect = {},
  studentList = [],
  dataPoint = {},
  getDashboard = (e: string) => { },
  isOpen = false,
  setIsOpen = (e: boolean) => { }
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [students, setStudents] = useState<any>([...studentList]);
  const [isToken, setIsToken] = useState<any>(false);
  const { t } = useTranslation();
  const [data, setData] = useState<any>({ ...dataPoint });
  const [studentSelected, setStudentSelected] = useState<any>({ ...studentSelect, photoUrl: '' });
  const env = Config.BaseUrlDev;

  useEffect(() => {
    try {
      if (location.pathname.split("/")[2] != undefined) {
        setIsToken(true);
        dispatch(setToken(location.pathname.split("/")[2]));
        credentialCheck().then((resCredential) => {
          dispatch(setUser(resCredential.data.user));
        });
        if (location.pathname.split("/")[3] != undefined) {
          var lang = location.pathname.split("/")[3];
          i18n.changeLanguage(lang);
          dispatch(setLanguage(lang));
        }
      }
    } catch (error) { }
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    if (location.pathname.split("/")[2] != undefined) { }
  }, [location.pathname.split("/")[2]]);

  function closeModal() {
    setIsOpen(false);
  }

  const handleRefresh = async () => { };

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <PullToRefresh className="text-center" onRefresh={handleRefresh}>
          <div className="text-left h-[95dvh]  px-4 py-6 bg-psp-primary top-to-bottom font-montserrat">
            <section className="mt-5 w-full h-full">
              <div className="flex flex-col justify-start h-full w-full">
                <div
                  onClick={() => setIsOpen(true)}
                  className="bg-white p-3 rounded-xl flex-row flex gap-1 items-center flex-0 w-full justify-between"
                >
                  <div className="flex flex-row gap-1 w-[60%]">
                    <div className="flex flex-row w-12 h-12 " >
                      <img
                        src={getProfileImage(studentSelected.photoUrl || '')}
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>
                    <div className="flex flex-col grow ">
                      <span className="font-montserrat text-xs font-medium text-psp-nav">
                        {handleLongText(studentSelected.name, 15)}
                      </span>
                      <span className="font-montserrat  font-medium text-psp-gray text-xs">
                        {studentSelected.callerId}
                      </span>
                      <span className="font-montserrat  font-medium text-psp-gray text-xs">
                        {studentSelected.classroomName}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col w-[37%] items-center">
                    <span className="font-montserrat text-3xl font-bold text-blue-600">
                      {data.totalPoint < 0 ? 0 : data.totalPoint}
                    </span>
                    <span className="font-montserrat font-medium text-psp-nav text-center text-sm">
                      Poin Akumulasi
                    </span>
                    <span className="font-montserrat font-medium text-psp-gray text-[9px]">
                      Total poin setelah perhitungan pelanggaran & reward.
                    </span>
                  </div>
                </div>
                <div
                  className="mt-5 flex flex-col gap-2">
                  <div
                    className="bg-white p-3 rounded-xl flex-col flex gap-3 w-full justify-between"
                  >
                    <div>
                      <img
                        src={rewardIcon}
                        className="size-15 object-cover rounded-xl"
                      />
                    </div>
                    <div className="flex justify-between">
                      <div>
                        <span className="flex flex-col text-sm">
                          Point Reward
                        </span>
                        <span className="text-psp-gray text-[10px]">
                          Poin reward digunakan untuk mengurangi poin pelanggaran melalui akumulasi dari kegiatan positif yang dilakukan siswa.
                        </span>
                      </div>
                      <div className="flex flex-col items-center">
                        <span className="font-bold text-4xl text-[#FFBE0C]">
                          {data.reward?.point || 0}
                        </span>
                        <span className="text-sm">Point</span>
                      </div>
                    </div>
                    <div className="flex justify-between">
                      <button
                        onClick={() => navigate('/point-guard/reward')}
                        className=" flex flex-row gap-2  px-3 py-1 border-1 border-[#0054e6] text-[#0054e6] font-medium text-xs rounded-md"
                      >
                        Detail
                      </button>
                      <button
                        onClick={() => navigate('/point-guard/reward/create')}
                        className=" flex flex-row gap-2  px-3 py-1 bg-[#0054e6] text-white font-medium text-xs rounded-md"
                      >
                        Tambah
                      </button>
                    </div>
                  </div>
                  <div
                    className="bg-white p-3 rounded-xl flex-col flex gap-3 w-full justify-between"
                  >
                    <div>
                      <img
                        src={punishIcon}
                        className="size-15 object-cover rounded-xl"
                      />
                    </div>
                    <div className="flex justify-between">
                      <div>
                        <span className="flex flex-col text-sm">
                          Point Pelanggaran
                        </span>
                        <span className="text-psp-gray text-[10px]">
                          Poin reward diberikan kepada siswa apabila melakukan suatu pelanggaran.
                        </span>
                      </div>
                      <div className="flex flex-col items-center">
                        <span className="font-bold text-4xl text-[#FF0000]">
                          {data.violation?.point || 0}
                        </span>
                        <span className="text-sm">Point</span>
                      </div>
                    </div>
                    <div className="flex justify-between">
                      <button
                        onClick={() => navigate('/point-guard/violation')}
                        className="flex flex-row gap-2 px-3 py-1 border-1 border-[#0054e6] text-[#0054e6] font-medium text-xs rounded-md"
                      >
                        Detail
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </PullToRefresh>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-2 text-center w-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex flex-row">
                      Pilih
                    </div>
                  </Dialog.Title>
                  <div className="rounded-2xl bg-psp-primary mt-3 p-2 flex flex-col gap-2">
                    {
                      students.length > 0 && students.map((res: any) =>
                        <div
                          onClick={() => {
                            changeStudent(res)
                          }}
                          className="bg-white p-3 rounded-xl flex-row flex gap-1 items-center flex-0 w-full justify-between"
                        >
                          <div className="flex flex-row gap-1 w-[70%]">

                            <div className="flex flex-row w-12 h-12 " >
                              <img
                                src={getProfileImage(res.photoUrl || '')}
                                className="w-full h-full object-cover rounded-full"
                              />
                            </div>
                            <div className="flex flex-col grow ">
                              <span className="font-montserrat text-xs font-medium text-psp-nav">
                                {res.name}
                              </span>
                              <span className="font-montserrat  font-medium text-psp-gray text-xs">
                                {res.callerId}
                              </span>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default ViolationPointMobile;
